import { createContext, PropsWithChildren, useContext } from 'react';

import { useShadowBzObjectApi } from './use-shadow-bz-object-api';

type ShadoBzObjectApi = ReturnType<typeof useShadowBzObjectApi>['1'];

interface ShadowBzObjectApiProviderProps {
  value: ShadoBzObjectApi;
}

const ShadowBzObjectContext = createContext<ShadoBzObjectApi | null>(null);

export const ShadowBzObjectApiProvider = (
  props: PropsWithChildren<ShadowBzObjectApiProviderProps>
) => {
  const { children, value } = props;
  return (
    <ShadowBzObjectContext.Provider value={value}>
      {children}
    </ShadowBzObjectContext.Provider>
  );
};

export const useShadowBzObjectApiContext = () => {
  const state = useContext(ShadowBzObjectContext);
  if (!state) {
    throw new Error(
      'Context is null. Make sure you wrapped your component with <ShadowBzObjectContext />'
    );
  }
  return state;
};
